import PracticeSdk from 'shared-assets/lib/sdk/practice';
import { PracticeSettings } from "@kareo/billing-system";

(function () {
  angular
    .module('kareo.ui.shared.modules.api.practice.k-practice-service', [])
    .factory('kPracticeService', kPracticeService);

  kPracticeService.$inject = ['$http', '$timeout'];
  function kPracticeService($http, $timeout) {
    const svc = {};
    const cacheConfig = PracticeSdk.getCacheConfig();

    svc.getAllPractices = getAllPractices; // gets all practices accessible by the authenticated user for the session customer
    svc.getPracticeDetail = getPracticeDetail; // gets the current practice's details
    svc.getServiceLocations = getServiceLocations;
    svc.getPracticeSelfPay = getPracticeSelfPay;

    return svc;

    // ---------------------------------------------------------------------

    function getAllPractices() {
      return $http.get('/common-ui/api/User/practices', {
        cache: true
      }).then((response) => {
        return response.data;
      });
    }

    function getPracticeDetail() {
      return PracticeSdk.practiceInfo().then((response) => response);
    }

    function getPracticeSelfPay() {
      return $http.get(`/common-ui/api/Practice/setting/${PracticeSettings.SELF_PAY_PRACTICE}`, cacheConfig).then((response) => {
        return response.data;
      });
    }

    function getServiceLocations() {
      return $timeout(() => {
        return [
          {
            serviceLocationId: 0,
            name: 'Service Location 1'
          },
          {
            serviceLocationId: 1,
            name: 'Service Location 2'
          },
          {
            serviceLocationId: 2,
            name: 'Service Location 3'
          }
        ];
      }, 250);
    }
  }
})();
